// ─── Datos para pagar por transferencia, de CADA seminario (SEC-3) ─────────
// Antes estaban escritos en el código del portal y los veían los alumnos de
// todos los seminarios. Ahora son configuración del seminario
// (`config.bankTransfer`), los edita su administración en Configuración, y el
// portal los pide al servidor (solo para miembros de ESE seminario).
//
// Se guardan siempre como textos (vacío = sin dato): «borrar» un campo de la
// configuración no funciona hoy con updateTenantConfig (se guarda con merge),
// así que vaciar los campos es la forma de dejar de mostrarlos.
export const BANK_TRANSFER_FIELDS = [
    'holder',
    'taxId',
    'bank',
    'accountType',
    'accountNumber',
    'email',
];
export const BANK_TRANSFER_MAX = 120;
/** Lo que se muestra: null si falta lo mínimo para transferir (titular, banco y
 *  número de cuenta). Sin datos configurados, el bloque no aparece. */
export function resolveBankTransfer(config) {
    const raw = config?.bankTransfer;
    if (!raw)
        return null;
    const clean = Object.fromEntries(BANK_TRANSFER_FIELDS.map((k) => [k, typeof raw[k] === 'string' ? raw[k].trim() : '']));
    if (!clean.holder || !clean.bank || !clean.accountNumber)
        return null;
    return clean;
}
//# sourceMappingURL=bank-transfer.js.map